import AclName from '../AclName';

const excluded = [
  AclName.AmqpQueuesList,
  AclName.CrmBtnAgreementFileSend,
  AclName.CrmBtnSwitchAccountAsIs,
  AclName.CrmBtnSwitchInactiveAccount,
  AclName.CrmFormCrmSaveDeletedItem,
  AclName.CrmBtnCreateCrmEvenIfImpersonated,
  AclName.SettingsPageBasePriceListsEdit,
  AclName.SettingsPageBasePriceListsDelete,
  AclName.SettingsPageSubscriptionPanel,
  AclName.DemoMessageStart,
  AclName.SettlementsBrokerView,
  AclName.CrmAddNewAsIndustryTypeAo,
  AclName.CrmBtnSystemBalanceManualRecharge,
  AclName.SettingsPageSystemRolesList,

  AclName.SettingsPageSystemTaskList,
  AclName.SettingsPageSystemTaskEdit,
  AclName.CrmSectionSystemBalancePrepaid,
  AclName.CrmPageSubscriptionPanel,

  AclName.CrmPageBillingList,
  AclName.CrmPageBillingSettle,
  AclName.CrmPageBankingOperationsList,
  AclName.CrmPageBankingOperationsSettle,

  // wyłączenie uprawnień i przeniesienie ich na inne role
  AclName.StaffAccessAll,
  AclName.StaffPageAccidentInsurancesList,
  AclName.StaffPageAccidentInsurancesEdit,
  AclName.FilesPageFilesList,
  AclName.BookkeepingPageDeclarationsVatList,
  AclName.BookkeepingPageDeclarationsPitList,
  AclName.BookkeepingPageZusCompanySettlementsList,
  AclName.CrmPageMyAgreementsList,
  AclName.BookkeepingInvoicesAccessAll,
  AclName.BookkeepingEvidencesAccessAll,
  AclName.EmployeeAddEditCompanyDataTabAccess,
  AclName.ProfileEditCompanyDataTabAccess,
  AclName.ProfileViewCompanyDataCardAccess,
  AclName.FinancialSummaryView,

  // Edycja profilu
  AclName.CanEditKsefSettings,

  AclName.ProfileViewCompanyDataIndustryTypesAccess,

  AclName.MailingSelectedAllBtn,
  AclName.MailingAdmin,

  // Developer settings
  AclName.UserInfoDialogAccess,
];

export default Object.values(AclName).filter(acl => !excluded.includes(acl));
